import { Flex } from "@mantine/core";
import { useMediaQuery } from "@mantine/hooks";
import { FieldValues, FormProvider, UseFormReturn } from "react-hook-form";

interface IProps<TFormValues extends FieldValues> {
  children: React.ReactNode;
  methods: UseFormReturn<TFormValues>;
}
const LayoutFormAuth = <TFormValues extends FieldValues>({
  children,
  methods,
}: IProps<TFormValues>) => {
  const isLargerThan991 = useMediaQuery("(min-width: 991px)");
  return (
    <Flex
      px={{ base: 0, 991: 64, 1300: 100, 1800: 200 }}
      align={{ base: "start", 991: "center" }}
      justify={"center"}
      w="100%"
      h="100%"
      id="LayoutFormAuth"
    >
      <FormProvider {...methods}>
        <Flex
          p={{ base: "0", 991: 32 }}
          direction="column"
          justify={{ base: "start", 991: "center" }}
          align={{ base: "start", 991: "center" }}
          w="100%"
          h="100%"
          gap={7}
        >
          <Flex
            bg={"basic.0"}
            p={{ base: 24, 550: 48 }}
            gap={{ base: 24 }}
            w="100%"
            sx={{
              borderRadius: isLargerThan991 ? "12px" : "none",
              boxShadow: isLargerThan991
                ? "0px 25px 35px rgba(0, 0, 0, 0.03)"
                : "none",
            }}
          >
            {children}
          </Flex>
        </Flex>
      </FormProvider>
    </Flex>
  );
};

export default LayoutFormAuth;
